/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {BannerEl} from 'common/components/banner';
import {BannerAction, BannerSize, BannerType} from 'common/components/banner/types';

import type {SharingBanner} from './index';

export function template(this: SharingBanner) {
  return (
    <div sel='.sharing-banner'>
      {this.helpers.shouldShow() ? (
        <BannerEl
          attrs={{
            elref: `shareBanner`,
            theme: `info`,
            type: BannerType.Embedded,
            size: BannerSize.Small,
            'body-text': this.helpers.getShareBannerText(),
            ctas: window.localStorage && [{text: `Dismiss`, actionName: BannerAction.Dismiss}],
            'style-override': `
          .banner-wrapper .banner-panel {padding: 8px;}
          .banner-wrapper .banner-panel .banner-actions {margin-bottom: 0}
          .banner-wrapper .banner-panel .banner-copy {margin-bottom: 0}
          .banner-wrapper .banner-panel .banner-actions .cta-button.banner-action-button-embedded.info-theme {border: none;}
        `,
          }}
          on={{action: this.helpers.handleBannerAction}}
        />
      ) : null}
    </div>
  );
}
